import Image from '@/src/components/CustomImage'
import classNames from 'classnames'
import React from 'react'
import styles from './index.module.scss'

interface PriceRes {
  currency: 'CNY' | 'USD'
  list: {
    original: number
    price: number
    sku: string
    track: number
    unit: string
  }[]
}
interface Section6Props {
  message: any
  priceRes: PriceRes
  isChina: boolean
}

const Section6: React.FC<Section6Props> = ({ message, isChina, priceRes }) => {
  const { currency, list = [] } = priceRes
  const symbol = currency === 'USD' ? '$' : '¥'
  const isEn = currency === 'USD'

  const steps = [
    {
      imgSrc: `/assets/images/api/Part6_1_${isChina ? 'zh' : 'en'}.png`,
      spanText: message.__tellUs
    },
    {
      imgSrc: `/assets/images/api/Part6_2_${isChina ? 'zh' : 'en'}.png`,
      spanText: message.__support
    },
    {
      // imgSrc: `/assets/images/api/Part6_3_${isChina ? 'zh' : 'en'}.png`,
      imgSrc: `/assets/images/api/Part6_3_ol_${isChina ? 'zh' : 'en'}.png`,
      spanText: message.__volume
    },
    {
      imgSrc: `/assets/images/api/Part6_4_${isChina ? 'zh' : 'en'}.png`,
      spanText: message.__goLive
    }
  ]

  const prices = list.slice(0, 4).map((val, index) => {
    const titleArr = [
      message.__skus_versionBasic,
      message.__skus_versionAdvanced,
      message.__skus_versionProfessional,
      message.__skus_versionFlagship
    ]
    return {
      title: titleArr[index],
      ...val
    }
  })

  const formatUnitPrice = (track: number, price: number) => {
    return message.__skus_professionalSkuAndPrice
      .replace('{0}', track?.toLocaleString())
      .replace('{1}', `${symbol}${price?.toLocaleString()}`)
  }
  return (
    <section className={styles.section6}>
      <div className={styles.container}>
        <div className={styles.title}>
          <h2>{message.__integrationTogether}</h2>
          <h3>{message.__skus_desc?.replace('{0}', 12)}</h3>
        </div>

        <ul className={styles.priceSku}>
          {prices.map((ele, index) => (
            <li key={ele.sku} className={styles.priceCard}>
              <div className={classNames(styles.priceTitle, index === 3 ? styles.hot : '')}>
                <span>{ele.title}</span>
              </div>
              <div className={styles.price}>
                <span>{message.__skus_unitPrice}</span>
                <h4>
                  {symbol}
                  {ele.unit}
                </h4>
              </div>
              <span className={styles.priceUnit}>{formatUnitPrice(ele.track, ele.price)}</span>
            </li>
          ))}

          <li key="custom sku" className={`${styles.priceCard} ${styles.illustration}`}>
            <span className={styles.priceTitle}>{message.__skus_versionCustom}</span>
            {isEn ? (
              <>
                <Image src="/assets/images/api/illustration.png" width={128} height={128} alt="custom model" />
                <button className={styles.customerButton} onClick={() => window.scrollTo({ top: 0 })}>
                  <span>{message.__contactus}</span>
                </button>
              </>
            ) : (
              <>
                <Image src="/assets/images/api/davi-qrcode.png" width={128} height={128} alt="contact us qrCode" />
                <span className={styles.subTitle}>{message.__skus_customTitleCN}</span>
              </>
            )}
          </li>
        </ul>

        <div className={styles.board}>
          <h3>{message.__completeTheIntegra}</h3>
          <ul className={styles.steps}>
            {steps.map((e, idx) => (
              <li key={idx} className={styles.imageCard}>
                <Image src={e.imgSrc} alt={e.spanText} width={486} height={480} />
                <div className={styles.borderTip}>{idx + 1}</div>
                <span>{e.spanText}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Section6
